import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Regisztracio from './Regisztracio';
import { regisztracioCel } from '../../vazlat';

// A /rendezveny/:rendezvenyID/regisztracio oldal: az azonosító az útvonalból jön (frissítés és Vissza gomb működik).
// Vendégnek a védelem a lista belépő ablakát nyitja meg ehhez a rendezvényhez.
function RegisztracioBetolto({ rendezvenyID, ...props }) {
    const navigate = useNavigate();
    const [kesz, setKesz] = useState(false);

    // Friss adatokkal döntünk: ha a felhasználónak már van megrendelése erre a rendezvényre (fizetett vagy nem),
    // azt nyitjuk meg, nem hozunk létre másodikat.
    useEffect(() => {
        props.frissitFelhasznalo(function (f) {
            if (f.megrendeltRendezvenyekByID[rendezvenyID] !== undefined) {
                navigate(regisztracioCel(f, rendezvenyID), { replace: true });
            } else {
                setKesz(true);
            }
        });
    }, []);

    if (!kesz) {
        return <div className="betoltes">Töltés...</div>;
    }
    return <Regisztracio {...props} rendezvenyID={rendezvenyID} betoltottMegrendelesData={undefined} />;
}

export default function RegisztracioOldal({ vedett, ...props }) {
    const { rendezvenyID } = useParams();
    return vedett(
        <RegisztracioBetolto key={rendezvenyID} rendezvenyID={rendezvenyID} {...props} />,
        { rendezvenyID: Number(rendezvenyID) }
    );
}
